@if (shouldShowWidget) {
  <div class="quick-connect-widget" [class.minimized]="isMinimized">
    
    <!-- Widget Header -->
    <div class="widget-header" 
         [class.clickable]="isMinimized" 
         (click)="isMinimized && toggleMinimized()"
         [attr.title]="isMinimized ? 'Klicken zum Erweitern' : ''">
      <div class="header-content" [class.maximized]="!isMinimized">
        <div class="widget-title">
          <div class="flower-icon">🌸</div>
          @if (!isMinimized) {
            <span class="custom-title-small title-text">Schnell kontaktieren</span>
          }
        </div>
        <div class="header-actions">
          <button 
            class="minimize-button" 
            (click)="$event.stopPropagation(); toggleMinimized()"
            [attr.aria-label]="isMinimized ? 'Widget erweitern' : 'Widget minimieren'">
            <mat-icon [svgIcon]="isMinimized ? 'expand' : 'minimize'" aria-hidden="true"></mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Widget Content -->
    @if (!isMinimized) {
      <div class="widget-content">
        <div class="custom-body-small subtitle">Wie können wir Ihnen helfen?</div>
        
        <!-- Dynamic Actions based on configuration order -->
        @for (action of enabledActions; track action.id) {
          
          <!-- Phone Action -->
          @if (action.type === 'phone' && hasPhone()) {
            <div class="primary-actions">
              <button class="action-button primary phone" (click)="makePhoneCall()">
                <div class="action-icon">
                  <mat-icon svgIcon="phone" aria-hidden="true"></mat-icon>
                </div>
                <div class="action-content">
                  <div class="custom-title-small action-title">{{ getActionLabel('phone') || 'Anrufen' }}</div>
                  <div class="custom-body-small action-subtitle">{{configuration().contactData.phone || configuration().contactData.mobile}}</div>
                </div>
              </button>
            </div>
          }

          <!-- Email Action -->
          @if (action.type === 'email' && hasEmail()) {
            <div class="primary-actions">
              <button class="action-button primary email" (click)="sendEmail()">
                <div class="action-icon">
                  <mat-icon svgIcon="email" aria-hidden="true"></mat-icon>
                </div>
                <div class="action-content">
                  <div class="custom-title-small action-title">{{ getActionLabel('email') || 'E-Mail senden' }}</div>
                  <div class="custom-body-small action-subtitle">{{configuration().contactData.email}}</div>
                </div>
              </button>
            </div>
          }

          <!-- WhatsApp Action -->
          @if (action.type === 'whatsapp' && hasSocialMedia(SocialMediaPlatform.WhatsApp)) {
            <div class="primary-actions">
              <button class="action-button primary whatsapp" (click)="openWhatsApp()">
                <div class="action-icon">
                  <mat-icon svgIcon="whatsapp" aria-hidden="true"></mat-icon>
                </div>
                <div class="action-content">
                  <div class="custom-title-small action-title">{{ getActionLabel('whatsapp') || 'WhatsApp' }}</div>
                  <div class="custom-body-small action-subtitle">Direkt chatten</div>
                </div>
              </button>
            </div>
          }

          <!-- Order Action -->
          @if (action.type === 'order') {
            <div class="primary-actions">
              <button class="action-button primary order" (click)="openOrderForm()">
                <div class="action-icon">
                  <mat-icon svgIcon="order-star" aria-hidden="true"></mat-icon>
                </div>
                <div class="action-content">
                  <div class="custom-title-small action-title">{{ getActionLabel('order') || 'Bestellen' }}</div>
                  <div class="custom-body-small action-subtitle">Blumen online bestellen</div>
                </div>
              </button>
            </div>
          }

          <!-- Contact Form Action -->
          @if (action.type === 'contact-form') {
            <div class="secondary-actions">
              <button class="action-button secondary contact-form" (click)="openContactForm()">
                <div class="action-icon">
                  <mat-icon svgIcon="contact-form" aria-hidden="true"></mat-icon>
                </div>
                <span class="custom-body-small">{{ getActionLabel('contact-form') || 'Kontaktformular' }}</span>
              </button>
            </div>
          }

          <!-- Directions Action -->
          @if (action.type === 'directions' && hasAddress()) {
            <div class="secondary-actions">
              <button class="action-button secondary directions" (click)="openDirections()">
                <div class="action-icon">
                  <mat-icon svgIcon="location" aria-hidden="true"></mat-icon>
                </div>
                <span class="custom-body-small">{{ getActionLabel('directions') || 'Route planen' }}</span>
              </button>
            </div>
          }

          <!-- Social Media Action -->
          @if (action.type === 'social' && hasAnySocialMedia()) {
            <div class="social-actions">
              <div class="custom-label-small social-title">Folgen Sie uns</div>
              <div class="social-links">
                @for (platform of socialMediaPlatforms; track platform) {
                  @if (hasSocialMedia(platform)) {
                    <button class="social-button {{ platform | lowercase }}" (click)="openSocialMedia(platform)">
                      <mat-icon [svgIcon]="platform | lowercase" aria-hidden="true"></mat-icon>
                    </button>
                  }
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
}
